import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NgLetModule } from 'ng-let';
import { TranslateModule } from '@ngx-translate/core';

import { GoogleLoginComponent, LoginInfoComponent } from './login.component';
import { RoleDirective } from './role.directive';

@NgModule({
    imports: [CommonModule, IonicModule, TranslateModule, NgLetModule],
    exports: [GoogleLoginComponent, LoginInfoComponent, RoleDirective],
    declarations: [GoogleLoginComponent, LoginInfoComponent, RoleDirective],
    providers: []
})
export class UserModule {}
